import { memo } from "react";
import styled from "styled-components";

const StyledSpacer = styled.div<{ color: string }>`
  width: 1px;
  background: ${(props: any) => props.color};
  margin: 8px 0;
`;

interface SpacerProps {
  color: string;
  className?: string;
}

const Spacer = (props: SpacerProps) => {
  const { color, className } = props;

  return <StyledSpacer color={color} className={className} />;
};

export default memo(Spacer);
